import React, { useEffect, useRef, useState } from "react";
import { Download, FileText, BookOpen, Workflow, ClipboardCheck, GitBranch, Scale, Send, Globe2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const DOCUMENTS = [
  {
    id: "intro",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/hsd3znsd_6f45b470-189a-4de1-84a6-7af3731f66d2.pdf",
    titleKey: "downloads.docs.intro.title",
    descKey: "downloads.docs.intro.desc",
    icon: BookOpen,
    color: "#E8792B",
  },
  {
    id: "starter",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/o8vpdrrg_bf66d014-739f-461d-b391-35e1e2934fd9.pdf",
    titleKey: "downloads.docs.starter.title",
    descKey: "downloads.docs.starter.desc",
    icon: ClipboardCheck,
    color: "#2980B9",
  },
  {
    id: "guide",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/0vveziti_44f2d36d-1308-4c88-bdb6-ee94559a5ca3.pdf",
    titleKey: "downloads.docs.guide.title",
    descKey: "downloads.docs.guide.desc",
    icon: FileText,
    color: "#27AE60",
  },
  {
    id: "flowchart",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/p5obfz5f_357a7fba-9472-4d33-b5f5-9a7e4a5c10ce.pdf",
    titleKey: "downloads.docs.flowchart.title",
    descKey: "downloads.docs.flowchart.desc",
    icon: Workflow,
    color: "#8E44AD",
  },
  {
    id: "actionPlan",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/foj59u6w_c86f1aa1-a210-4652-b1e5-8b1c9edb10f6.pdf",
    titleKey: "downloads.docs.actionPlan.title",
    descKey: "downloads.docs.actionPlan.desc",
    icon: GitBranch,
    color: "#D35400",
  },
  {
    id: "policy",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/r9zppemx_World%20Athletics%20Safeguarding%20Policy.pdf",
    titleKey: "downloads.docs.policy.title",
    descKey: "downloads.docs.policy.desc",
    icon: Globe2,
    color: "#1a1a2e",
  },
  {
    id: "rules",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/tt4jalaj_D1.2%20-%20Safeguarding%20Rules.pdf",
    titleKey: "downloads.docs.rules.title",
    descKey: "downloads.docs.rules.desc",
    icon: Scale,
    color: "#C0392B",
  },
  {
    id: "reportingGuidance",
    url: "https://customer-assets.emergentagent.com/job_athletics-platform/artifacts/crsmy90r_0aa99076-ca3a-4f94-8daa-5051ac4bd674.pdf",
    titleKey: "downloads.docs.reportingGuidance.title",
    descKey: "downloads.docs.reportingGuidance.desc",
    icon: Send,
    color: "#F39C12",
  },
  {
    id: "template",
    titleKey: "downloads.docs.template.title",
    descKey: "downloads.docs.template.desc",
    icon: FileText,
    color: "#16A085",
    languages: [
      { code: "en", label: "English", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/792a63aa9c96e751_English.pdf" },
      { code: "ar", label: "العربية", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/fe7e583a037727ac_Arabic.pdf" },
      { code: "es", label: "Español", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/0300b020d4a7501b_Spain.pdf" },
      { code: "fr", label: "Français", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/65e48f82b9ad62a3_French.pdf" },
      { code: "it", label: "Italiano", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/ab4944a46ef5177a_Italian.pdf" },
      { code: "pt", label: "Português", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/9395015422737b2c_Portuguese.pdf" },
      { code: "nl", label: "Nederlands", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/7818320da680e9be_Dutch.pdf" },
      { code: "pl", label: "Polski", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/3b2adc310a5d2d72_Polish.pdf" },
      { code: "ru", label: "Русский", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/1a0bfe7f2a73e598_Russian.pdf" },
      { code: "zh", label: "中文", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/70f6e6cd230136fb_Chinese.pdf" },
      { code: "hi", label: "हिन्दी", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/1b77056928f7222f_Hindi.pdf" },
      { code: "ur", label: "اردو", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/4ca9a01c44dc4bb8_urdu%20hindi.pdf" },
      { code: "ko", label: "한국어", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/4b8d61fb20b23289_Korean.pdf" },
      { code: "ja", label: "日本語", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/ca4a54cc611436e5_Japanese.pdf" },
      { code: "id", label: "Bahasa Indonesia", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/9f15941068504124_Indonesian.pdf" },
      { code: "vi", label: "Tiếng Việt", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/8c25061f44f4722f_Vietnamese.pdf" },
      { code: "fil", label: "Filipino", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/40dd7bc55578a242_Filipino.pdf" },
      { code: "om", label: "Afaan Oromoo", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/e421d5b11fd994cf_Oromo.pdf" },
      { code: "trp", label: "Kokborok", url: "https://customer-assets-eiarnc6j.emergentagent.net/job_athletics-platform/artifacts/fa999481a840e698_Kokborok.pdf" },
    ],
  },
];

const DownloadsSection = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="downloads" ref={sectionRef} className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className={`mb-12 max-w-4xl transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="inline-flex items-center justify-center w-14 h-14 bg-[#E8792B]/10 rounded-xl mb-6">
            <Download className="w-7 h-7 text-[#E8792B]" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] mb-4">
            {t("downloads.title")}
          </h2>
          <div className="w-20 h-1 bg-[#E8792B] rounded-full mb-6" />
          <p className="text-gray-600 text-base leading-relaxed">{t("downloads.intro")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {DOCUMENTS.map((doc, index) => {
            const Icon = doc.icon;
            const num = String(index + 1).padStart(2, "0");
            const isMulti = Array.isArray(doc.languages) && doc.languages.length > 0;
            const Wrapper = isMulti ? "div" : "a";
            const wrapperProps = isMulti
              ? {}
              : {
                  href: doc.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  download: true,
                };
            return (
              <Wrapper
                key={doc.id}
                {...wrapperProps}
                data-testid={`download-${doc.id}`}
                className={`group relative overflow-hidden p-8 lg:p-10 bg-white border border-gray-200 hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-all duration-500 flex flex-col ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                }`}
                style={{
                  transitionDelay: `${index * 80}ms`,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = doc.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "";
                }}
              >
                {/* Faded number watermark in doc color */}
                <div
                  className="absolute -bottom-8 -right-2 font-black text-[140px] lg:text-[180px] leading-none pointer-events-none select-none"
                  style={{ color: doc.color, opacity: 0.07 }}
                >
                  {num}
                </div>

                {/* Top hairline accent that grows on hover */}
                <span
                  className="absolute top-0 left-0 h-px w-12 transition-all duration-500 group-hover:w-full"
                  style={{ backgroundColor: doc.color }}
                />

                {/* PDF badge in top-right */}
                <span
                  className="absolute top-5 right-5 text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1"
                  style={{
                    backgroundColor: `${doc.color}10`,
                    color: doc.color,
                    border: `1px solid ${doc.color}33`,
                  }}
                >
                  PDF
                </span>

                {/* Square icon tile */}
                <div
                  className="relative inline-flex items-center justify-center h-12 w-12 transition-all duration-300 group-hover:shadow-[0_0_24px_rgba(0,0,0,0.12)]"
                  style={{
                    backgroundColor: `${doc.color}10`,
                    border: `1px solid ${doc.color}66`,
                  }}
                >
                  <Icon className="h-5 w-5" style={{ color: doc.color }} strokeWidth={2} />
                </div>

                <div
                  className="relative mt-8 text-[11px] font-bold tracking-[0.3em]"
                  style={{ color: doc.color, opacity: 0.75 }}
                >
                  · {num} ·
                </div>

                <h3 className="relative mt-4 text-[18px] lg:text-[20px] font-bold leading-[1.2] text-[#1a1a2e] tracking-tight">
                  {t(doc.titleKey)}
                </h3>

                <p className="relative mt-4 text-gray-600 text-[14px] leading-relaxed max-w-[36ch] flex-grow">
                  {t(doc.descKey)}
                </p>

                {/* Download action row */}
                {isMulti ? (
                  <div className="relative mt-6 flex flex-wrap gap-2" data-testid={`download-${doc.id}-languages`}>
                    {doc.languages.map((lng) => (
                      <a
                        key={lng.code}
                        href={lng.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        data-testid={`download-${doc.id}-${lng.code}`}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] border transition-all duration-200 hover:text-white"
                        style={{
                          color: doc.color,
                          borderColor: `${doc.color}66`,
                          backgroundColor: `${doc.color}08`,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = doc.color;
                          e.currentTarget.style.color = "#ffffff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = `${doc.color}08`;
                          e.currentTarget.style.color = doc.color;
                        }}
                      >
                        <Download className="h-3 w-3" />
                        <span>{lng.label}</span>
                      </a>
                    ))}
                  </div>
                ) : (
                  <div
                    className="relative mt-8 flex items-center gap-2 text-[10px] uppercase tracking-[0.24em] font-bold transition-all duration-300"
                    style={{ color: doc.color }}
                  >
                    <span
                      className="h-px w-6 transition-all duration-300 group-hover:w-10"
                      style={{ backgroundColor: doc.color }}
                    />
                    <span>{t("downloads.download")}</span>
                    <Download className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-y-0.5" />
                  </div>
                )}
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DownloadsSection;
